import React from "react";
import { Link } from "react-router-dom";
import { CalendarDays, ArrowRight, RefreshCw } from "lucide-react";
import { fetchLatestResult } from "../lib/api";
import { useCachedData } from "../lib/useCachedData";

function formatDMY(iso) {
  if (!iso) return "--/--/----";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
}

function Digit({ value }) {
  return (
    <span className="inline-flex items-center justify-center w-[74px] h-[74px] sm:w-[88px] sm:h-[88px] rounded-full border-[3px] border-[#ff4500]/60 bg-orange-50/50 text-slate-900 font-num text-4xl sm:text-5xl font-extrabold">
      {value ?? "--"}
    </span>
  );
}

export function LiveResultCard({
  title = "MORNING SUNDAY TEER RESULT",
  previousHref = "/morning-teer-previous-result/",
}) {
  const { data, refresh } = useCachedData("mst:latest", fetchLatestResult, {
    pollMs: 60000,
  });

  return (
    <div
      data-testid="live-result-card"
      className="bg-white rounded-2xl card-shadow border border-slate-200 overflow-hidden max-w-2xl mx-auto"
    >
      <div className="bg-gradient-to-r from-[#ff4500] to-[#f97316] px-5 py-3 flex items-center justify-between">
        <h2 className="text-white font-head font-bold text-base sm:text-lg tracking-wide text-center flex-1">
          {title}
        </h2>
        <button
          onClick={refresh}
          data-testid="result-refresh-btn"
          aria-label="Refresh result"
          className="text-white/90 hover:text-white ml-2"
        >
          <RefreshCw size={18} />
        </button>
      </div>

      <div className="px-5 sm:px-8 py-6">
        <div className="flex items-center justify-center gap-2 text-slate-700 font-semibold mb-6">
          <CalendarDays size={18} className="text-[#ff4500]" />
          <span data-testid="result-date">Date: {formatDMY(data?.date)}</span>
        </div>

        <div className="grid grid-cols-2 items-center">
          <div className="flex flex-col items-center gap-3">
            <p className="text-sm sm:text-base font-bold text-slate-800">F/R (10:30 AM)</p>
            <div data-testid="result-fr">
              <Digit value={data?.fr} />
            </div>
          </div>
          <div className="flex flex-col items-center gap-3 border-l border-slate-200">
            <p className="text-sm sm:text-base font-bold text-slate-800">S/R (11:30 AM)</p>
            <div data-testid="result-sr">
              <Digit value={data?.sr} />
            </div>
          </div>
        </div>

        <Link
          to={previousHref}
          data-testid="check-previous-results-btn"
          className="mt-7 w-full bg-[#0f172a] hover:bg-slate-800 text-white font-semibold rounded-full py-3 flex items-center justify-center gap-2 transition-colors"
        >
          Check Previous Results <ArrowRight size={18} />
        </Link>
      </div>
    </div>
  );
}
